<template>
  <div class="border-form radius-6 product-ticket">
    <div class="row">
      <div class="col-md-9 col-12">
        <div class="h-100 py-md-4 pl-md-4 pr-md-0 p-3">
          <div class="w-100">
            <p class="mb-0 sub-heading-1-2">{{ data.name }}</p>
            <ul class="pl-3 my-2">
              <li><p class="mb-0 body-2-2 responsive">{{ lowest_variant.is_refundable ? $t('merchant.refundable') : $t('merchant.non-refundable') }}</p></li>
              <li v-if="$isNotEmpty(lowest_variant.validity_term)"><p class="mb-0 body-2-2 responsive">{{lowest_variant.validity_term}}</p></li>
              <li v-if="$isNotEmpty(lowest_variant.validity_term)"><p class="mb-0 body-2-2 responsive">{{lowest_variant.validity_term}}</p></li>
              <li v-if="$isNotEmpty(data.is_flexible_service_date)"><p class="mb-0 body-2-2 responsive">Tickets can be redeemed within {{ data.flexible_service_date_max_late }} days from the date of visit.</p></li>
            </ul>
            <p class="overline mb-0 text-green cursor-pointer text-uppercase d-table ml-auto" @click="toggleDetail">View Details</p>
          </div>
          <div class="w-100 mt-4 pt-4 border-2-top-dashed" v-if="is_product_in_cart != -1 || show_variant">
            <div 
              class="w-100" 
              v-for="(variant,variant_index) in data.variants"
              :class="{
                'mb-md-4 mb-3 pb-md-4 pb-3 border-b-semi-grey': (variant_index+1) < data.variants.length
              }">
              <Variant :data="variant" :product="data" :product_index_vuex="is_product_in_cart"></Variant>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="p-md-4 p-3 h-100 bg-custom-light">
          <template v-if="data.total_availability > 0">
            <div class="row no-gutters" v-if="is_product_in_cart == -1">
              <div class="col-md-12 col-8 mb-md-3 mb-0 align-self-center text-md-center text-left">
                <p class="body-3-3-1 mb-0">Starting from</p>
                <p class="mb-0 text-20 text-green font-lato lh-1">{{ $formatCurrency(lowest_variant.start_price) }}</p>
              </div>
              <div class="col-md-12 col-4 align-self-center">
                <button class="g-btn g-btn-md g-btn-secondary w-100" @click="toggleVariant()">Select</button>
              </div>
            </div>
            <div class="row no-gutters" v-else>
              <div class="col-md-12 col-8 mb-md-3 mb-0 align-self-center text-md-center text-left">
                <p class="body-3-3-1 mb-0">Total Selected</p>
                <p class="mb-0 text-20 text-green font-lato lh-1">{{ $formatCurrency(total_price_selected) }}</p>
              </div>
              <div class="col-md-12 col-4 align-self-center">
                <button class="g-btn g-btn-md g-btn-dark w-100" @click="resetCart">Cancel</button>
              </div>
            </div>
          </template>
          <button v-else class="g-btn g-btn-md g-btn-light w-100">Out Of Stock</button>
        </div>
      </div>
    </div>

    <!-- PRODUCT DETAIL -->
    <popup-detail 
      id_ref="product_detail"
      direction="bottom" 
      :show="show_detail"
      use_max_size
      wrapper_size="mobile"
      @close="toggleDetail">
      <template v-slot:body>
        <div class="w-100 position-relative" style="height:270px;">
          <img :src="data.cover_image_url" class="img-fit radius-12-t" />
          <div class="bg-white rounded-circle position-absolute border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetail()">
            <img src="../../assets/img/icon/close.png" width="14" />
          </div>
        </div>
        <div class="p-4">
          <div class="w-100 mb-4">
            <p class="mb-1 sub-heading-1-2">{{ data.name }}</p>
            <div class="html-desc body-2-2" v-html="data.description"></div>
          </div>
          <div v-if="$isNotEmpty(data.product_detail)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
            <div class="row no-gutters" v-b-toggle.product_detail>
              <div class="col-10 align-self-center">
                <p class="mb-0 body-1-4 text-ticket">Product Detail</p>
              </div>
              <div class="col-2 align-self-center text-right">
                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                  <path
                    d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                    class="fill-text-t" />
                </svg>
              </div>
            </div>
            <b-collapse id="product_detail" class="border-t-dashed-secondary-t pt-4 mt-4">
              <p class="mb-0 body-2-2 html-desc" v-html="data.product_detail"></p>
            </b-collapse>
          </div>
          <div v-if="$isNotEmpty(data.cancellation_policy)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
            <div class="row no-gutters" v-b-toggle.cancellation_policy>
              <div class="col-10 align-self-center">
                <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.cancellation-policy') }}</p>
              </div>
              <div class="col-2 align-self-center text-right">
                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                  <path
                    d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                    class="fill-text-t" />
                </svg>
              </div>
            </div>
            <b-collapse id="cancellation_policy" class="border-t-dashed-secondary-t pt-4 mt-4">
              <p class="mb-0 body-2-2 html-desc" v-html="data.cancellation_policy"></p>
            </b-collapse>
          </div>
          <div v-if="$isNotEmpty(data.terms_conditions)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
            <div class="row no-gutters" v-b-toggle.terms_conditions>
              <div class="col-10 align-self-center">
                <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.terms-and-conditions') }}</p>
              </div>
              <div class="col-2 align-self-center text-right">
                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                  <path
                    d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                    class="fill-text-t" />
                </svg>
              </div>
            </div>
            <b-collapse id="terms_conditions" class="border-t-dashed-secondary-t pt-4 mt-4">
              <p class="mb-0 body-2-2 html-desc" v-html="data.terms_conditions"></p>
            </b-collapse>
          </div>
          <div v-if="$isNotEmpty(data.how_to_redeem)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
            <div class="row no-gutters" v-b-toggle.how_to_redeem>
              <div class="col-10 align-self-center">
                <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.how-to-redeem') }}</p>
              </div>
              <div class="col-2 align-self-center text-right">
                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                  <path
                    d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                    class="fill-text-t" />
                </svg>
              </div>
            </div>
            <b-collapse id="how_to_redeem" class="border-t-dashed-secondary-t pt-4 mt-4">
              <p class="mb-0 body-2-2 html-desc" v-html="data.how_to_redeem"></p>
            </b-collapse>
          </div>
        </div>
      </template>
      <!-- <template v-slot:footer>
        <div class="p-4">
          <button 
            @click="toggleProductDetail()"
            class="mt-2 g-btn g-btn-secondary-ticket g-btn-lg w-100" >
            {{ $t('ticket.close-detail') }}
          </button>
        </div>
      </template> -->
    </popup-detail>
  </div>
</template>

<script>
  import Variant from './Variant'
  import { mapGetters,mapActions } from 'vuex'
  import _ from 'lodash';

  export default {
    props: ['data'],
    components:{
      Variant
    },
    data(){
      return{
        show_detail: false,
        show_variant: false
      }
    },
    computed:{
      ...mapGetters(['getTicketCart','getMerchant']),
      cart(){
        return this.getTicketCart.ticket_details
      },
      is_product_in_cart(){
        let index = -1
        if(this.cart.length > 0) index = this.cart.findIndex(x=>x.ticket.id == this.data.id)
        return index
      },
      total_price_selected(){
        let total = 0
        if(this.is_product_in_cart != -1){
          this.cart[this.is_product_in_cart].variant.forEach(item=>{
            total += (item.data.best_price.best_price.final_price*item.qty)
          })
        }
        return total
      },
      lowest_variant(){
        let return_data = {}

        if(this.data.variants.length > 0){
          let copied_data = _.cloneDeep(this.data.variants)
          let sorted = copied_data.sort((a,b)=>a.price_sell_discount-b.price_sell_discount)
          for(let i = 0 ; i < sorted.length; i++){
            if(sorted[i].price_sell_discount > 0){
              return_data = sorted[i]
              return_data.start_price = return_data.best_price.best_price.final_price
              break;
            }
          }
        }
        
        return return_data
      }
    },
    methods:{
      ...mapActions(['ticketAddItemCart','ticketClearItemCart']),
      toggleVariant(){
        this.show_variant = !this.show_variant
      },
      addVariantToCart(){
				for(let i = 0; i < this.data.variants.length; i++){
          if (this.data.variants[i].availability > 0) {
            
            let data = {
              ticket: this.$deepCopy(this.data),
              variant: this.data.variants[i]
            }
            delete data.ticket.variants
            this.ticketAddItemCart(data)
            break;
          }
        }
			},
      resetCart(){
        this.ticketClearItemCart(this.data)
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      }
    }
  }
</script>
<style>
  @media screen and (max-width: 768px){
    .product-ticket .sub-heading-1-2{
      font-size: 16px;
    }
    .product-ticket .body-2-2.responsive{
      font-size: 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/Product.vue